var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/GasStations
 */
import Control from './Control';
import MapControls from './MapControls';
import LonLat from '../LonLat';
import Marker from '../Marker';
import Icon from '../Icon';
import InfoMap from '../InfoMap';
import PoisMap from '../MapPois';
import { i18n } from '../dictionary';
import { IMG } from '../globals';
import VControlButton from '../view/VControlButton';
import VDropDown, { EventType as DropDownEventType } from '../view/VLayerSwitcher';
import VGasStationPopup, { EventType as GasStationEventType } from '../view/VGasStationPopup';
import { isMobile, getDOMRelativePosition } from '../view/VUtils';
/**
* @type {Object<string, string>}
* @api
*/
export var Options = {
    /**
      * No layer region option
      * @api
      */
    NONE: 'none',
    /**
    * Neighborhoods
    * @api
    */
    GAS_STATIONS: 'D00GAS',
    /**
    * Postal codes
    * @api
    */
    NATURAL_GAS_STATIONS: 'D00GNC',
    /**
    * Municipalities
    * @api
    */
    ELECTRIC_CHARGERS: 'D104',
};
/**
 * @classdesc
 * <b>Javascript ES5</b>
 *
 * ```js
 * const control = new cercaliagl.control.GasStations();
 * ```
 * <br/>
 * Class <b>cercaliagl.control.GasStations</b> provides gas station POIs by around the world. Spain gas stations has more detailed information,
 * these gas stations has the price of differents oils.
 * POIs are drawn and grouped by zoom. Those are calculated on demand while user is panning on map.
 *
 * To access to this control and enable it:
 *
 * ```js
 * const map = new cercaliagl.Map({ target: 'map' });
 * const gasStationControl = map.getControlByName(cercaliagl.control.MapControls.GAS_STATIONS);
 * gasStationControl.enable();
 * ```
 *
 * @extends {Control}
 * @api
 */
var GasStations = /** @class */ (function (_super) {
    __extends(GasStations, _super);
    /**
     * @constructor
     */
    function GasStations() {
        var _this = this;
        var controlButton = new VControlButton('gasstation');
        var element = controlButton.getElement();
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.GasStations',
            name: MapControls.GAS_STATIONS,
        }) || this;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {VGasStationPopup}
         */
        _this.gasstationPopup_ = new VGasStationPopup();
        /**
         * @private
         * @type {VDropDown}
         */
        _this.dropdown_ = new VDropDown();
        _this.dropdown_.setSelected(null);
        /**
         * @private
         * @type {Array.<import("../view/VLayerSwitcher").Item>}
         */
        _this.items_ = [
            { id: Options.GAS_STATIONS, value: i18n('gasstations'), iconName: 'icon-gasolinera' },
            { id: Options.NATURAL_GAS_STATIONS, value: i18n('naturalgasstations'), iconName: 'icon-gn' },
            { id: Options.ELECTRIC_CHARGERS, value: i18n('electricchargers'), iconName: 'icon-electrics' },
        ];
        /**
         * @private
         * @type {PoisMap}
         */
        _this.tilePoiMap_ = null;
        /**
         * @private
         * @type {boolean}
         */
        _this.enabled_ = false;
        /**
         * @private
         * @type {Array.<string>}
         */
        _this.categories_ = [];
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    GasStations.prototype.initialize_ = function () {
        var _this = this;
        this.controlButton_.setTooltip(i18n('tooltipGasStations'));
        this.element_.addEventListener('click', this.handleClick_.bind(this));
        window.addEventListener('resize', this.adjustPosition_.bind(this));
        this.dropdown_.on(DropDownEventType.SELECTED, function (item) { return _this.enableOption(item.id); });
        this.dropdown_.on(DropDownEventType.DESELECTED, function () { return _this.disable(); });
        this.gasstationPopup_.on(GasStationEventType.DIRECTION_TO, function (e) { return _this.handleDirectionTo_(e); });
        this.initializeListItems_();
    };
    /**
    * @param {string} option Option to enable. See above
    * @api
    */
    GasStations.prototype.enableOption = function (option) {
        // this.categories_.push(option);
        if (this.categories_.includes(option)) {
            this.disable();
            this.dropdown_.hide();
            return;
        }
        this.categories_ = [option];
        this.enable();
    };
    /**
     * @private
     */
    GasStations.prototype.initializeListItems_ = function () {
        var _this = this;
        this.items_.forEach(function (item) {
            _this.dropdown_.add(item);
        });
    };
    /**
     * @private
     */
    GasStations.prototype.adjustPosition_ = function () {
        var relativePos = getDOMRelativePosition(this.element_, this.getMap().getContainer());
        var htmlElement = this.dropdown_.getElement();
        htmlElement.style.top = isMobile() ? '' : "".concat(relativePos.top + this.element_.offsetHeight + 4, "px");
        htmlElement.style.right = isMobile() ? "".concat(Math.abs(relativePos.right) + 4, "px") : "".concat(Math.abs(relativePos.right), "px");
        htmlElement.style.bottom = isMobile() ? "".concat(Math.abs(relativePos.bottom) + 42, "px") : '';
    };
    /**
     * @private
     * @param {LonLat} position Position
     */
    GasStations.prototype.handleDirectionTo_ = function (position) {
        var map = this.getCercaliaMap();
        var mapRouting = map.getMapRouting();
        mapRouting.routeFromCurrentPositionToDestination(position);
    };
    /**
     * @private
     */
    GasStations.prototype.handleClick_ = function () {
        if (!this.dropdown_.isVisible()) {
            // Right align to button.
            var container = this.getMap().getContainer();
            if (!this.dropdown_.getElement().parentElement) {
                this.dropdown_.appendTo(container);
            }
            this.adjustPosition_();
            this.dropdown_.show();
        }
        else {
            this.dropdown_.hide();
        }
    };
    /**
     * Enable gas station markers
     * @override
     * @api
     */
    GasStations.prototype.enable = function () {
        if (this.categories_.length === 0) {
            this.dropdown_.setSelected(this.items_[0].id);
            this.enableOption(this.items_[0].id);
            return;
        }
        if (this.mapPois_) {
            this.mapPois_.disable();
        }
        this.mapPois_ = new PoisMap({
            map: this.getCercaliaMap(),
            categories: this.categories_,
            createMarkersFunction: this.createMarkersFunction_.bind(this),
        });
        this.mapPois_.enable();
        this.enabled_ = true;
        this.controlButton_.enable();
        if (!this.gasstationPopup_.getElement().closest('body')) {
            var container = this.getMap().getContainer();
            this.gasstationPopup_.appendTo(container);
        }
        this.dropdown_.hide();
    };
    /**
     * Disable gas station markers
     * @override
     * @api
     */
    GasStations.prototype.disable = function () {
        if (this.mapPois_) {
            this.mapPois_.disable();
            this.mapPois_ = null;
        }
        this.enabled_ = false;
        this.dropdown_.setSelected(null);
        this.controlButton_.disable();
        this.categories_ = [];
    };
    /**
     * Create a list of markers to paint from server json, a BBOX and zoom level.
     * @private
     * @param {Array.<import('../servers').PoisResultDataPoi>} data Json downloaded from server.
     * @param {import('../Bounds').default} bounds BBOX (bounds).
     * @param {number} zoom Zoom level.
     * @return {Array.<Marker>} Markers array.
     */
    GasStations.prototype.createMarkersFunction_ = function (data) {
        var markers = [];
        var currentZoom = this.getMap().getZoom();
        for (var i = 0; i < data.length; i += 1) {
            var elem = data[i];
            var imgId = void 0;
            var zoomIcon = false;
            if (elem.subcategory_id && elem.subcategory_id !== '-1') {
                imgId = elem.subcategory_id;
                if (currentZoom >= 13) {
                    zoomIcon = true;
                }
            }
            else {
                imgId = elem.category_id;
            }
            var position = new LonLat(elem.coord.x, elem.coord.y);
            var img = "".concat(IMG, "/gasstations/").concat(imgId).concat(zoomIcon ? '_Zoom' : '', ".png");
            var name_1 = elem.name.value;
            var info = elem.info.value;
            var ge = elem.ge;
            var municipalityId = ge && ge.municipality ? ge.municipality.id : null;
            var marker = new Marker(/** @type {import('../Marker').MarkerOptions} */ ({
                id: elem.id ? elem.id : null,
                position: position,
                icon: new Icon(/** @type {import('../Icon').IconOptions} */ ({
                    src: img,
                })),
                onClick: this.handleGasStationClick_.bind(this, position, municipalityId, name_1, info, imgId),
            }));
            markers.push(marker);
        }
        return markers;
    };
    /**
     * @private
     * @param {LonLat} position Position.
     * @param {string} municipalityId Municipality Id.
     * @param {string} name Name.
     * @param {string} info Info POI field.
     */
    GasStations.prototype.handleGasStationClick_ = function (position, municipalityId, name, info, imgId) {
        if (imgId === void 0) { imgId = Options.GAS_STATIONS; }
        var countryId = municipalityId.substring(0, 3);
        if (countryId === 'ESP') {
            this.viewInterface_.closePopups();
            if (imgId === Options.NATURAL_GAS_STATIONS) {
                this.gasstationPopup_.updateWithNaturalGasStation(position, name, info);
            }
            else if (imgId === Options.ELECTRIC_CHARGERS) {
                this.gasstationPopup_.updateWithElectricCharger(position, name, info);
            }
            else {
                this.gasstationPopup_.update(position, name, info);
            }
            this.gasstationPopup_.show();
        }
        else {
            var arrInfo = info.split('|');
            var direccion = '';
            var localidad = '';
            var telefon = '';
            if (imgId === Options.ELECTRIC_CHARGERS) {
                // eslint-disable-next-line prefer-destructuring
                direccion = arrInfo[0];
            }
            else {
                direccion = arrInfo[1].trim();
                localidad = arrInfo[2].trim();
                telefon = arrInfo[3].trim();
            }
            var content = "<div>\n        <div class=\"address\">".concat((direccion ? "".concat(direccion, ", ") : '') + (localidad || i18n('gasStation')), "</div>\n        <div><span>").concat(telefon, "</span></div>\n      </div>");
            var infoMap = new InfoMap(/** @type {import('../InfoMap').InfoMapOptions} */ ({
                title: name,
                content: content,
            }));
            var map = this.getCercaliaMap();
            map.showInfoMap(infoMap);
        }
    };
    /**
     * Close gas station UI popup
     * @api
     */
    GasStations.prototype.closePopup = function () {
        this.gasstationPopup_.hide();
    };
    return GasStations;
}(Control));
export default GasStations;
//# sourceMappingURL=GasStations.js.map